import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { HomeIcon, TargetIcon, CheckCircleIcon, AwardIcon, UserIcon, LogOutIcon, ClipboardListIcon, CheckIcon } from 'lucide-react';
interface LayoutProps {
  children: React.ReactNode;
  onLogout?: () => void;
  userRole?: string;
}
const Layout: React.FC<LayoutProps> = ({
  children,
  onLogout,
  userRole = 'student'
}) => {
  const location = useLocation();
  // Different navigation items for students and teachers
  const studentNavItems = [{
    path: '/',
    label: '首页',
    icon: <HomeIcon size={20} data-id="element-44" />
  }, {
    path: '/submit-goal',
    label: '提交学习目标',
    icon: <TargetIcon size={20} data-id="element-45" />
  }, {
    path: '/achievements',
    label: '我的积分和勋章',
    icon: <AwardIcon size={20} data-id="element-46" />
  }];
  const teacherNavItems = [{
    path: '/',
    label: '首页',
    icon: <HomeIcon size={20} data-id="element-47" />
  }, {
    path: '/review-submissions',
    label: '审核完成情况',
    icon: <ClipboardListIcon size={20} data-id="element-48" />
  }, {
    path: '/award-badges',
    label: '发放勋章',
    icon: <AwardIcon size={20} data-id="element-49" />
  }];
  const navItems = userRole === 'teacher' ? teacherNavItems : studentNavItems;
  return <div className="flex min-h-screen bg-gray-50" data-id="element-50">
      {/* Sidebar Navigation */}
      <div className="w-64 bg-white shadow-md" data-id="element-51">
        <div className="p-4 border-b border-gray-100" data-id="element-52">
          <h1 className="text-xl font-bold text-blue-600" data-id="element-53">学习目标打卡</h1>
          <p className="text-sm text-gray-500" data-id="element-54">
            {userRole === 'teacher' ? '教师管理端' : '学生打卡端'}
          </p>
        </div>
        <nav className="p-4" data-id="element-55">
          <ul className="space-y-2" data-id="element-56">
            {navItems.map(item => <li key={item.path} data-id="element-57">
                <Link to={item.path} className={`flex items-center p-2 rounded-lg transition-colors ${location.pathname === item.path ? 'bg-blue-50 text-blue-600' : 'text-gray-700 hover:bg-gray-100'}`} data-id="element-58">
                  <span className="mr-3" data-id="element-59">{item.icon}</span>
                  <span data-id="element-60">{item.label}</span>
                </Link>
              </li>)}
            {onLogout && <li className="mt-8 pt-4 border-t border-gray-100" data-id="element-61">
                <button onClick={onLogout} className="flex items-center p-2 rounded-lg text-gray-700 hover:bg-gray-100 w-full" data-id="element-62">
                  <span className="mr-3" data-id="element-63">
                    <LogOutIcon size={20} data-id="element-64" />
                  </span>
                  <span data-id="element-65">退出登录</span>
                </button>
              </li>}
          </ul>
        </nav>
      </div>
      {/* Main Content */}
      <div className="flex-1 p-8 overflow-auto" data-id="element-66">{children}</div>
    </div>;
};
export default Layout;